import { useSelector } from 'react-redux';
import { semesters } from 'keys';
import { isEmpty } from 'lodash';
import { useQueryClient } from '@tanstack/react-query';
import { queryClient as qc } from 'keys'
import { semesterAndYearOptions } from 'keys/years';
import { assessmentStatusOptions } from 'keys/statuses';
import { CategoriesOptions } from 'components/Categories';


const useHeaderItems = () => {
    const queryClient = useQueryClient()
    const { grades } = useSelector(state => state.testTaker)
    const batteries = queryClient.getQueryData([qc.batteries])

    const headerItems = {
        year: {
            id: 1,
            placeholder: "שנת ביצוע",
            options: semesterAndYearOptions,
            name: "school_year",
            component: "autoComplete",
            width: 100
        },
        semester: {
            id: 2,
            placeholder: "סמסטר",
            options: semesters,
            name: "semester",
            component: "autoComplete",
            width: 180,
            disabled: assessmentFilters => isEmpty(assessmentFilters?.year) && isEmpty(assessmentFilters?.grade_of_execution)
        },
        grade_of_execution: {
            id: 1,
            placeholder: "שכבה בעת ביצוע",
            options: grades,
            name: "grade_of_execution",
            component: "autoComplete",
            width: 100
        },
        category: {
            id: 0,
            placeholder: "סוג מבדק",
            name: "category",
            component: "autoComplete",
            labelKey: "label",
            // open: true,
            width: 400,
            paperComponent: CategoriesOptions
        },
        assessment_def: {
            id: 3,
            placeholder: "מבדק",
            // options: queryClient.getQueryData(qc.assessmentDefs)?.data,
            name: "assessment_def",
            component: "autoComplete",
            multiple: true,
            width: 250
        },
        status: {
            id: 4,
            name: "status",
            placeholder: "סטטוס מבדק",
            component: "autoComplete",
            multiple: true,
            options: assessmentStatusOptions
        },
        battery: {
            id: 5,
            name: "battery",
            placeholder: "סוללה",
            component: "autoComplete",
            options: batteries,
            labelKey: "label",
            minWidth: 300
        }
    }

    return headerItems
}

export default useHeaderItems